// extracted by mini-css-extract-plugin
export default {"skeleton-container":"styles_skeleton-container__+KqAo","skeleton-box":"styles_skeleton-box__5PW2o","skeleton-content":"styles_skeleton-content__53qMy"};